/* istanbul ignore file */
/******************************************
 *  Author : vsuthar
 *  Created On : Thu Sep 02 2021
 *  File : index.js
 *  ©Palo Alto Networks
 *******************************************/

import { useCallback, useContext, useMemo, useState } from 'react'
import { noop } from '@panwds/react-ui'
import Identities from './components/identities/Identities'
import Roles from './components/roles/Roles'
import {
  VIEW_MANAGE_IAM,
  VIEW_IAM_ROLES,
  VIEW_IAM_PROVIDERS,
  VIEW_ADD_CUSTOM_ROLE,
  VIEW_EDIT_CUSTOM_ROLE,
  VIEW_IAM_TENANT,
} from '../common/constants/GlobalConstants'
import CustomRoleForm from './components/roles/CustomRoleForm'
import IDP from './components/idp/IDP'
import GlobalContext from '../common/context/GlobalContext'
import LoadingProvider from '../common/context/LoadingContext'
import IpRestrictProvider from '../common/context/IpRestrictContext'
import IAMContent from './IAMContent'
import { getVarValue } from '../common/utils/Sparky'
import { FF_DEFAULT_TSG } from '../common/utils/FeatureFlags'
import AuthContext from '../common/context/AuthContext'
import AddTenantPage from '../tenancy/components/licenses/AddTenantPage'

const enableDefaultTSG = getVarValue(FF_DEFAULT_TSG)

const IAM = (props) => {

  const { auth } = useContext(AuthContext)
  const { dispatch } = useContext(GlobalContext)
  const { selectedTreeNode, breadcrumbs, onBreadCrumbClick, currentView, commonModule } = props
  const [canListPolicies, setCanListPolicies] = useState(true)
  const [canListRoles, setCanListRoles] = useState(true)

  const page = useCallback(({ getData }) => {
    switch (currentView) {
      case VIEW_EDIT_CUSTOM_ROLE:
      case VIEW_ADD_CUSTOM_ROLE:
        return <CustomRoleForm {...{ getData }}/>
      case VIEW_IAM_ROLES:
        return <Roles {...{ getData, canListRoles }}/>
      case VIEW_IAM_PROVIDERS:
        return <IDP/>
      case VIEW_IAM_TENANT:
        return <AddTenantPage />
      case VIEW_MANAGE_IAM:
      default:
        return <Identities {...{ getData, canListPolicies }} />
    }
  }, [currentView, canListRoles, canListPolicies])

  const showSideBar = useMemo(() => {
    if (enableDefaultTSG && !auth?.tsgs?.hasMsp) {
      return false
    }
    switch (currentView) {
      case VIEW_EDIT_CUSTOM_ROLE:
      case VIEW_IAM_PROVIDERS:
      case VIEW_ADD_CUSTOM_ROLE:
        return false
      case VIEW_IAM_ROLES:
      case VIEW_MANAGE_IAM:
      default:
        return true
    }
  }, [currentView, auth?.tsgs?.hasMsp])

  const contentProps = {
    dispatch,
    children: page,
    selectedTreeNode,
    breadcrumbs,
    onBreadCrumbClick,
    setCanListPolicies,
    setCanListRoles,
    showSideBar,
    commonModule,
    currentView
  }

  return (
    <IpRestrictProvider>
      <LoadingProvider>
        <IAMContent {...contentProps} />
      </LoadingProvider>
    </IpRestrictProvider>
  )
}

IAM.defaultProps = {
  selectedTreeNode: {},
  breadcrumbs: new Map(),
  onBreadCrumbClick: noop,
  currentView: null,
}
export default IAM
